<template>
  <div class="qa-answer-focus-on-bar" v-if="isShow">
    <div class="wrapper">
      <div class="avatar-wrap" @click.prevent="linkToUserIndex">
        <img :src="author.url | imgZip(200)" class="user-img" />
      </div>
      <div class="user-name">
        <div class="flex-box">
          <div class="user-name-inner">
            <p @click.prevent="linkToUserIndex">
              {{ author.name }}
            </p>
          </div>
          <ExposedLabel
            :style="{ 'margin-top': 0 }"
            :listType="1"
            :userIdentifyVoList="userIdentifyVoList"
            :userLevel="userLevel"
            :isShowNormalTag="false"
          ></ExposedLabel>
        </div>
        <div class="level-text normal-info">{{ normalInfo }}</div>
      </div>
      <yxl-button
        v-show="!author.hasFollowed"
        @click.prevent="follow(author.id)"
        :round="true"
        class="focus-on-button"
        type="primary"
        :plain="true"
        :class="{ like: author.hasFollowed }"
        style="position: relative"
      >
        <template v-if="!author.hasFollowed">
          <div class="flex-box">
            <i class="icon icon-node-website icon-focus"></i> 关注
          </div>
        </template>
        <template v-else>已关注 </template>
      </yxl-button>
    </div>
  </div>
</template>

<script>
import yxlButton from 'component/common/button'
import ExposedLabel from 'app/web/component/platform/exposedLabel.vue'
import { isObject } from 'utils/tool.js'
import { followUser } from 'api/article'

export default {
  name: 'focusOnBar',
  components: {
    yxlButton,
    ExposedLabel
  },
  props: {
    author: {
      type: Object,
      default() {
        return {
          id: '',
          url: '',
          name: '',
          role: '',
          articleId: '',
          hasFollowed: false
        }
      }
    },
    detail: {
      type: Object,
      default: () => ({})
    },
    source: {
      type: String,
      default: ''
    }
  },
  computed: {
    isShow() {
      return !!this.author.name
    },
    normalInfo() {
      const list =
        this.userIdentifyVoList.filter(item => +item.isWork !== 1) || []
      return list.map(item => item.identifyName).join('/')
    },
    userIdentifyVoList() {
      const { userIdentifyVoList } = this.detail
      return Array.isArray(userIdentifyVoList) ? userIdentifyVoList : []
    },
    userLevel() {
      const { userLevel } = this.detail
      return userLevel && isObject(userLevel.level) ? userLevel.level : {}
    }
  },
  methods: {
    downloadApp() {
      // 需求https://devops.aliyun.com/projex/Req/73d6b70b80a514c2d976a6c949# 《平台-分享埋点优化》
      window.location.href = 'https://sdata.xinli001.com/t/5s'
      // let isIOS = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)
      // // 如果是IOS，直接调起Apple Store
      // if (isIOS) {
      //   window.location.href =
      //     'https://itunes.apple.com/app/apple-store/id994051627?pt=1667142&ct=m5&mt=8'
      // } else {
      //   window.location.href = `https://m.xinli001.com/download?utm_source=${this.source}`
      // }
    },
    goToApp() {
      if (this.$platform.isYixinliApp) return
      this.downloadApp()
    },
    linkToUserIndex() {
      if (!this.author.id) return
      this.$emit('beforeToUser')
      this.routerPush(
        `https://m.xinli001.com/homepage/${this.author.id}?node=1&hideNavigationBar=1&channle_flag=Platform_content_QA`
      )
    },
    // 关注
    async follow(id) {
      // 已登录或者App内可以正常关注
      if (this.$store.state.userinfo && this.$store.state.userinfo.token) {
        try {
          const res = await followUser({ user_id: id })
          if (res.code === 0) {
            this.$emit('update')
            this.$emit('afterToggleFollow', res.data?.is_follow == 1)
            this.$toast(res.data?.is_follow == 1 ? '已关注' : '已取消关注')
          } else {
            this.$toast(res.message, 500)
          }
        } catch (e) {
          console.log(e)
        }
      } else {
        if (this.$platform.isYixinliApp) {
          this.toLogin()
        } else {
          this.downloadApp()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.qa-answer-focus-on-bar {
  padding: 20px 0 0;
  background-color: #fff;
  .level-text {
    font-size: 24px;
    font-weight: 400;
    color: #9da3ac;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 360px;
    margin-top: 6px;
  }

  .flex-box {
    display: flex;
    align-items: center;
  }
  .icon-focus {
    margin-right: 6px;
  }
  .ml10 {
    margin-left: 10px;
  }
  .mt0 {
    margin-top: 0 !important;
  }

  .wrapper {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    width: 100%;
    padding-top: 20px;
    padding-bottom: 30px;

    .tag-list {
      height: 40px;
      white-space: nowrap;
    }

    .tag {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 20px;
      border-radius: 24px;
      border: 1px solid #9da3ac;
      color: #9da3ac;
      display: inline-block;
      padding: 5px 14px 3px;
      line-height: 24px;
      height: 24px;
      margin-top: 10px;

      margin-right: 10px;
    }

    .avatar-wrap {
      width: 80px;
      height: 80px;
      margin-right: 20px;
      flex-shrink: 0;
    }

    .user-img {
      margin-right: 20px;
      width: 100%;
      height: 100%;
      background-size: contain;
      overflow: hidden;
      border-radius: 50%;
      text-align: center;
      background-image: url(../../../images/common/default-avatar.png);
      flex-shrink: 0;
      object-fit: cover;
    }

    .user-name {
      margin-right: 20px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      ::v-deep .exposed-label {
        margin-top: 6px;
      }
      .user-name-inner {
        display: flex;
        align-items: center;
        max-width: 250px;
        margin-right: 8px;
        > p {
          font-size: 28px;
          color: #21252d;
          font-weight: 600;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
        span {
          font-size: 32px;
          color: #21252d;
          font-weight: bold;
        }
        .icon-identity {
          width: 35px;
          height: 35px;
          display: block;
          margin-left: 10px;
        }
      }
    }

    .user-desc {
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #9da3ac;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      max-width: 440px;
      margin-top: 6px;
    }

    .focus-on-button {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      margin-left: auto;
      color: #6982fa;
      height: 52px;
      min-width: 115px;
      text-align: center;
      box-sizing: border-box;
      background: #fff;
      border-radius: 30px;
      padding: 0 15px;
      border: 2px solid #6982fa;
      > span {
        display: flex;
        align-items: center;
      }
    }
  }
}

.consultant {
  display: flex;
  align-items: center;
  background: #f9f9f9;
  padding: 10px 20px;
  margin: 0 auto;
  border-radius: 10px;
  .info {
    flex: 1;
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
    display: flex !important;
    align-items: center;
    .msg-box {
      display: flex;
      flex-direction: column;
      .title {
        display: flex;
        align-items: center;
        & > img {
          width: 35px;
          height: 35px;
          display: block;
          margin-left: 10px;
        }
        .name {
          font-size: 28px;
          color: #21252d;
          line-height: 32px;
          height: 32px;
        }
        .zx_num {
          font-size: 24px;
          line-height: 24px;
          font-style: normal;
          font-weight: 400;
          padding-left: 20px;
        }
      }
      .brief {
        font-size: 24px;
        line-height: 32px;
        color: #9da3ac;
        margin-top: 8px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        word-break: break-all;
      }
    }

    .user-img {
      display: inline-block;
      margin-right: 20px;
      width: 80px;
      height: 80px;
      background-size: contain;
      overflow: hidden;
      border-radius: 50%;
      text-align: center;
      background-image: url(../../../images/common/default-avatar.png);
      flex-shrink: 0;
      object-fit: cover;
    }
  }
  .more {
    .right-icon {
      display: inline-block;
      width: 20px;
      height: 20px;
    }
  }
}

.icon-platform-vip {
  width: 35px;
  height: 35px;
  display: block;
  margin-left: 10px;
}

.is-platform-vip {
  color: #0b8bff !important;
}
</style>
